/* src/app/feature-modules/reports/tutor-reports/tutor-reports.component.css */
.no-report {
  text-align: center;
  border: dashed 4px rgb(143, 143, 143);
  padding: 14px;
  border-style: dashed;
}
.no-report h3 {
  font-size: 24px;
  color: rgb(143, 143, 143);
}
/*# sourceMappingURL=tutor-reports.component.css.map */
